import { render, staticRenderFns } from "./ControlsRepeatButton.vue?vue&type=template&id=2b5c0966&scoped=true&"
import script from "./ControlsRepeatButton.vue?vue&type=script&lang=js&"
export * from "./ControlsRepeatButton.vue?vue&type=script&lang=js&"
import style0 from "./ControlsRepeatButton.vue?vue&type=style&index=0&id=2b5c0966&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5c0966",
  null
  
)

export default component.exports